import React from 'react';
import styled from '@emotion/styled';

import Item from './item-pattern';
import { Link } from 'gatsby';
import { Button } from '@material-ui/core';

const Component: React.FCX = ({ className }) => (
  <div className={className}>
    <Item
      reverse={false}
      emoji='🍀'
      title='このサイト'
      description='Gatsbyで作ったウェブサイトを、Github Actionsを使ってNetlifyへデプロイしてます。BaaSは今後もっと活用していきたい。'
    />
    <Item
      reverse={true}
      emoji='🔌'
      title='Kintoneプラグイン'
      description='株式会社サイボウズの提供しているクラウドサービス「Kintone」で利用可能なプラグインを開発しています。'
    />

    <Item
      reverse={false}
      emoji='🧶'
      title='ブログ'
      description='ホスティングはGatsbyCloud、コンテンツ管理はContentful、プログラムはGithubという構成で作成。'
      addon={
        <Link
          to='https://ribbit.work'
          target='_blank'
          rel='noopener noreferre'
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <Button>サイトはこちら</Button>
        </Link>
      }
    />

    <Item
      reverse={true}
      emoji='💬'
      title='チャットボット'
      description='Chatwork × Google Apps Scriptで作成。Chatworkが提供しているWebhookからGASへデータを送り、対応するメッセージをPOSTするという方法で実装していました。'
    />
  </div>
);

const StyledComponent = styled(Component)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 0 3em;
`;

export default StyledComponent;
